import styled from "styled-components";
import { Modal } from "antd";

const StyledModal = styled(Modal)`
  &.ant-modal .ant-modal-header {
    margin-bottom: 18px;
  }

  .ant-table-container {
    background: #f1f5f6;
    border: 1px solid #d7d7d7;
    border-radius: 12px;
    padding: 24px;
  }

  .ant-table-wrapper .ant-table.ant-table-small .ant-table-cell {
    padding: 2px 0;
  }

  h4 {
    color: #052c2b;
    font-size: 20px;
    line-height: 24px;
    margin: unset;
  }
`;

export default StyledModal;
